import React, { useState } from "react";

import analytics from "fond/analytics";
import { useGetVersionStatusQuery } from "fond/api";
import LayerPanel from "fond/project/panels/InputPanel/LayerPanel";
import { useAppSelector } from "fond/utils/hooks";
import { ConfirmModal } from "fond/widgets";

import { getDesignEdits } from "../designEdits";
import { useDesignRefinementActions } from "../hooks/useDesignRefinementActions";

/**
 * Stacked navigation panel for moving the hubs of a completed design.
 */
const HubsRefinementPanel: React.FC = () => {
  const versionId = useAppSelector((state) => state.project.versionId);
  const { data: versionStatus } = useGetVersionStatusQuery(versionId, { skip: !versionId });
  const { hasDropAssignments } = getDesignEdits(versionStatus);
  const { moveHubs } = useDesignRefinementActions();
  const [showConfirm, setShowConfirm] = useState(false);

  const onDraw = () => {
    analytics.track("Clicked move equipment");
    if (hasDropAssignments) {
      setShowConfirm(true);
    } else {
      moveHubs({ resetDropAssignments: false });
    }
  };

  const onConfirm = () => {
    moveHubs({ resetDropAssignments: true });
    setShowConfirm(false);
  };

  return (
    <>
      {showConfirm && (
        <ConfirmModal
          open
          content="Drop assignments must be reset to move hubs. Are you sure you want to reset your drop assignments?"
          onConfirm={onConfirm}
          onCancel={() => setShowConfirm(false)}
        />
      )}
      <LayerPanel title="Hubs" layerKey="design-hubs" actions={["draw"]} drawSubtitle="Move hubs on the map" onDraw={onDraw} />
    </>
  );
};

export default HubsRefinementPanel;
